










































































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { MedTransGoConstants } from '../../util/constants';
import { ApiRequest } from '../../types/request';
import { CommonUtils } from '../../util/commonUtils';
import { Vehicle } from '@/types/response';

@Component({
     props: {
        id: String,
    },
     data() {
        return {
            make: '',
            model: '',
            color: '',
            year: '',
            licenseNumberPlate: '',
            vehicleNo: '',
            equippedForWheelchair: '',
            equippedForStretcher: '',
            };
        },
})
export default class ViewVehicleDetailModal extends Vue {
    private show = false;
    private vehicle: Vehicle = {} as any;
    private mounted() {
        this.getVehicles();
    }

    private async getVehicles() {
        const iHttpService = ObjectFactory.getHttpService();
        const vehicleId = this.$props.id;
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_VEHICLE}/${vehicleId}`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.get<Vehicle>(apiRequest);
        if (response.success && response.data) {
            response.data.equippedForStretcher = response.data.equippedForStretcher ? 'Yes' : 'No' as any;
            response.data.equippedForWheelchair = response.data.equippedForWheelchair ? 'Yes' : 'No' as any;
            this.vehicle = response.data;
            this.show = true;
        } else {
            CommonUtils.showError(response);
        }
    }

    private close() {
        this.$emit('close');
    }
}
